import { AnimatePresence, motion } from "framer-motion";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { fetchCities } from "../../redux/slices/citiesSlice";
import logo from "../../assets/icons/Logo_Full.webp"; // Make sure to have your logo here
import { setCity } from "../../redux/slices/citySelectionSlice";
import { useTranslation } from "react-i18next";

const CitySelectModal = ({ onSelect }) => {
  const dispatch = useDispatch();
  const { cities, loading, error } = useSelector((state) => state.cities);
  const { t, i18n } = useTranslation();

  const [selectedCity, setSelectedCity] = React.useState("");

  useEffect(() => {
    dispatch(fetchCities());
  }, [dispatch]);

  useEffect(() => {
    const savedLang = localStorage.getItem("language");
    if (savedLang && savedLang !== i18n.language) {
      i18n.changeLanguage(savedLang);
    }
  }, [i18n]);

  const handleConfirm = () => {
    if (selectedCity) {
      const fullCity = cities.find(c => c.id === Number(selectedCity));
      dispatch(setCity(fullCity));
      onSelect(selectedCity);
    }
  };

  const toggleLanguage = () => {
    const nextLang = i18n.language === "ar" ? "en" : "ar";
    i18n.changeLanguage(nextLang);
    localStorage.setItem("language", nextLang);
  };
  console.log(cities);
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center
     bg-black/50 backdrop-blur-sm">
      <AnimatePresence>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2 }}
          className="bg-white p-6 rounded-2xl w-80 lg:w-full max-w-md shadow-xl"
        >
          <div className="flex justify-between items-center mb-6">
            <img
              src={logo}
              alt="Logo"
              className={`w-40 h-auto ${i18n.language === "ar" ? "ml-auto" : "mr-auto"}`}
            />
            <button
              onClick={toggleLanguage}
              className="text-sm underline text-blue-600 hover:text-blue-800"
            >
              {i18n.language === "ar" ? "English" : "العربية"}
            </button>
          </div>

          <h2 className="text-2xl font-semibold mb-6 text-center">
            {i18n.language === "ar" ? " مدينة التوصيل" : "Select Your City"}
          </h2>

          {loading ? (
            <p className="text-center text-gray-600">{t("loading")}</p>
          ) : error ? (
            <p className="text-center text-red-500">{error}</p>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              {cities.map((city) => (
                <label
                  key={city.id}
                  className={`cursor-pointer p-3 border rounded-xl flex items-center justify-between gap-3 transition ${selectedCity === city.id ? "border-blue-600 bg-blue-100" : "border-gray-300"
                    }`}
                >
                  <div className="flex items-center gap-2">
                    <img
                      src={city.image}
                      alt="city"
                      width="32" height="32"
                      className="w-8 h-8 rounded-full object-cover"
                    />
                    <span>{i18n.language === "ar" ? city.a_name : city.e_name}</span>
                  </div>
                  <input
                    type="radio"
                    name="city"
                    value={city.id}
                    checked={selectedCity === String(city.id)}
                    onChange={() => setSelectedCity(String(city.id))}
                    className="accent-blue-600"
                  />
                </label>
              ))}
            </div>
          )}

          <button
            onClick={handleConfirm}
            disabled={!selectedCity}
            className="mt-6 w-full bg-blue-700 hover:bg-blue-800 text-white py-3 rounded-full disabled:opacity-50"
          >
            {i18n.language === "ar" ? "تأكيد المدينة" : "Confirm City"}
          </button>
        </motion.div>
      </AnimatePresence>

    </div>
  );
};

export default CitySelectModal;
